declare global {
  interface RouterMeta {
    title: string
    noLogin?: boolean
    jsonUrl?: string
    promotionType?: string
    data?: any
  }
  interface Router {
    path: string
    name: string
    icon?: string
    permission?: string
    meta?: RouterMeta
    component?: any
    groupName?: string
    hidden?: boolean
    children?: Array<Router>
    redirect?: string
  }
  interface System {
    import(request: string): Promise<any>
  }
  var System: System
}
import main from '../views/main.vue'
import Login from '../views/login/login.vue'
import defaultTable from '../views/formList/defaultTable.vue'
import defaultForm from '../views/formList/defaultForm.vue'

export const locking = {
  path: '/locking',
  name: 'locking',
  component: () =>
    import('../components/lockscreen/components/locking-page.vue'),
}
export const loginRouter: Array<Router> = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'LogIn',
      noLogin: true,
    },
    component: Login,
  },
  {
    path: '/callback',
    name: 'callback',
    meta: {
      title: 'LoginCallBack',
      noLogin: true,
    },
    component: Login,
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      title: 'logout',
      noLogin: true,
    },
    component: Login,
  },
  {
    path: '/401',
    name: '401',
    meta: {
      title: '401',
      noLogin: true,
    },
    component: () => import('../views/error/page401.vue'),
  },
  // 401 page must be placed at the end !!!
  {
    path: '*',
    name: '401',
    meta: {
      title: '访问出错',
      noLogin: true,
    },
    redirect: '/401',
  },
  {
    path: '/pchomeseting',
    meta: {
      title: 'pc首页装修',
      noLogin: false,
    },
    name: 'pcHomeSeting',
    component: () =>
      import('../views/shopMall/pcMallDecorate/homeSet/index.vue'),
  },
  {
    path: '/websiteHomepage',
    meta: {
      title: '今喜农官方商城',
      noLogin: true,
    },
    name: 'websiteHomepage',
    component: () =>
      import('../views/home/websiteHomepage.vue'),
  },
  {
    path: '/liveDetail',
    meta: {
      title: '你的田我来种',
      noLogin: true,
    },
    name: 'liveDetail',
    component: () =>
      import('../views/home/liveDetail.vue'),
  },
]
export const otherRouters: Router = {
  path: '/',
  name: 'main',
  permission: '',
  meta: { title: 'ManageMenu' },
  component: main,
  children: [
    {
      path: 'home',
      meta: { title: '系统首页' },
      name: 'home',
      component: () => import('../views/report/operationOverview.vue'),
    },
  ],
}
export const anonymousRouter: Array<Router> = [
  {
    path: '/shopWxaCode',
    name: 'shopWxaCode',
    meta: {
      title: '店铺二维码',
      noLogin: true,
    },
    component: () => import('../views/anonymous/shopWxacodeQuery/index.vue'),
  },
]
export const organizationRouters: Router = {
  path: '/organization',
  name: 'organization',
  permission: '',
  component: main,
  children: [
    {
      path: 'framework/channel/add',
      meta: { title: '新增渠道' },
      name: 'organizationFrameworkChannelAdd',
      component: () => import('../views/organization/edit/channel.vue'),
    },
    {
      path: 'framework/channel/edit/:id',
      meta: { title: '修改渠道' },
      name: 'organizationFrameworkChannelEdit',
      component: () => import('../views/organization/edit/channel.vue'),
    },
    {
      path: 'framework/store/add',
      meta: { title: '新增店铺' },
      name: 'organizationFrameworkStoreAdd',
      component: () => import('../views/organization/edit/store.vue'),
    },
    {
      path: 'framework/store/edit/:id',
      meta: { title: '修改店铺' },
      name: 'organizationFrameworkStoreEdit',
      component: () => import('../views/organization/edit/store.vue'),
    },
    {
      path: 'framework/channel/detail/:id',
      meta: { title: '渠道详情' },
      name: 'organizationFrameworkChannelDetail',
      component: () => import('../views/organization/detail/channel.vue'),
    },
    {
      path: 'framework/store/detail/:id',
      meta: { title: '店铺详情' },
      name: 'organizationFrameworkStoreDetail',
      component: () => import('../views/organization/detail/store.vue'),
    },
  ],
}
export const promotionActivityRouter: Router = {
  path: '/promotionActivity',
  name: 'promotionActivity',
  permission: '',
  component: main,
  children: [
    {
      path: 'productFilter/:id',
      meta: { title: '设置活动商品' },
      name: 'productFilter',
      component: () => import('../views/marketing/productFilter/index.vue'),
    },
  ],
}
export const appRouters: Array<Router> = [
  {
    path: '/',
    name: 'main',
    permission: 'MallConfigManagement.Home',
    meta: { title: '首页' },
    icon: 'ios-home-outline',
    component: main,
    children: [
      {
        path: 'home',
        permission: '',
        meta: { title: '系统首页' },
        icon: 'ios-home-outline',
        name: 'home',
        hidden: true,
        component: () => import('../views/report/operationOverview.vue'),
      },
      {
        path: 'operationOverview',
        permission: 'MallConfigManagement.Home.OperationOverview',
        icon: 'md-cube',
        meta: { title: '运营概况' },
        name: 'operationOverview',
        // groupName: '订单报表',
        component: () => import('../views/report/operationOverview.vue'),
      },
      {
        path: 'salesAnalysis',
        permission: 'MallConfigManagement.Home.SalesAnalysis',
        icon: 'md-cube',
        meta: { title: '商品销售分析' },
        name: 'salesAnalysis',
        // groupName: '订单报表',
        component: () => import('../views/report/salesAnalysis.vue'),
      },
      {
        path: 'orderReport',
        permission: 'MallConfigManagement.Home.OrderReport',
        icon: 'md-cube',
        meta: { title: '订单报表' },
        name: 'orderReport',
        // groupName: '订单报表',
        component: () => import('../views/report/order.vue'),
      },
      // {
      //   path: 'transactionAnalysis',
      //   permission: '',
      //   icon: 'md-cube',
      //   meta: { title: '交易分析' },
      //   name: 'transactionAnalysis',
      //   // groupName: '订单报表',
      //   component: () => import('../views/report/transactionAnalysis.vue')
      // },
      // {
      //   path: 'trafficAnalysis',
      //   permission: '',
      //   icon: 'md-cube',
      //   meta: { title: '流量分析' },
      //   name: 'trafficAnalysis',
      //   // groupName: '订单报表',
      //   component: () => import('../views/report/trafficAnalysis.vue')
      // },
      {
        path: 'loginLog',
        permission: 'MallConfigManagement.Home.LoginLog',
        icon: 'md-cube',
        meta: { title: '登录日志' },
        name: 'loginLog',
        // groupName: '订单报表',
        component: () => import('../views/report/loginLog.vue'),
      },
      {
        path: 'changePassword',
        icon: 'logo-buffer',
        permission: 'MallConfigManagement.Home.LoginLog',
        meta: { title: '账户设置' },
        name: 'changePassword',
        component: () => import('../views/home/changePassword.vue'),
      },
      // { path: 'log', permission: '', meta: { title: '登录日志' }, icon: "logo-buffer", name: 'log', component: () => import('../views/home/log.vue') },
      // { path: 'demo', permission: '', meta: { title: '表单配置Demo' }, icon: "md-attach", name: 'demo', component: () => import('../components/custom-form/demo/index.vue') }
    ],
  },
  // {
  //     path: '/organization',
  //     name: 'organization',
  //     permission: '',
  //     meta: { title: '组织' },
  //     icon: 'ios-options',
  //     component: main,
  //     children: [
  //         { path: 'framework', permission: '', icon: "md-ribbon", meta: { title: '组织架构' }, name: 'OrganizationFramework', component: () => import('../views/organization/framework.vue') }
  //     ]
  // },

  // {
  //   path: '/shopMall',
  //   name: 'shopMall',
  //   permission: 'MallConfigManagement.Mall',
  //   meta: { title: '商城' },
  //   icon: 'md-cube',
  //   component: main,
  //   children: [
  //     {
  //       path: 'pcMallDecorate',
  //       permission: 'MallConfigManagement.Mall.HomeSet',
  //       icon: 'md-cube',
  //       meta: { title: '商城装修' },
  //       name: 'pcMallDecorate',
  //       groupName: 'PC商城',
  //       // @ts-ignore
  //       component: () => import('../views/shopMall/pcMallDecorate/index.vue'),
  //     },
  //     {
  //       path: 'pcMallDecorate/seoConfig',
  //       // permission: 'MallConfigManagement.Mall.SeoConfig',
  //       hidden: true,
  //       icon: 'md-cube',
  //       meta: { title: 'SEO设置' },
  //       name: 'pcSeoConfig',
  //       groupName: 'PC商城',
  //       // @ts-ignore
  //       component: () =>
  //         import('../views/shopMall/pcMallDecorate/seoSet/index.vue'),
  //     },
  //     {
  //       path: 'pcMallDecorate/navSet',
  //       // permission: 'MallConfigManagement.Mall.NavSet',
  //       hidden: true,
  //       icon: 'md-cube',
  //       meta: { title: '导航栏设置' },
  //       name: 'pcNavSet',
  //       groupName: 'PC商城',
  //       // @ts-ignore
  //       component: () =>
  //         import('../views/shopMall/pcMallDecorate/navSet/index.vue'),
  //     },
  //     {
  //       path: 'pcMallDecorate/navSet/edit/:id?',
  //       permission: '',
  //       hidden: true,
  //       icon: 'md-cube',
  //       meta: { title: '导航栏编辑' },
  //       name: 'pcNavSetEdit',
  //       groupName: 'PC商城',
  //       // @ts-ignore
  //       component: () =>
  //         import('../views/shopMall/pcMallDecorate/navSet/edit/index.vue'),
  //     },
  //     {
  //       path: 'pcMallDecorate/homeSet',
  //       // permission: 'MallConfigManagement.Mall.HomeSet',
  //       hidden: true,
  //       meta: { title: '首页装修', jsonUrl: 'form/pcMallDecorate/homeSet' },
  //       name: 'pcHomeSet',
  //       component: () =>
  //         import(// @ts-ignore
  //         '../views/shopMall/pcMallDecorate/homeSet/list.vue'),
  //     },

  //     {
  //       path: 'pcMallDecorate/floorSet',
  //       permission: '',
  //       hidden: true,
  //       meta: { title: '首页楼层', jsonUrl: 'form/pcMallDecorate/floorSet' },
  //       name: 'pcFloorSet',
  //       component: () =>
  //         import(// @ts-ignore
  //         '../views/shopMall/pcMallDecorate/floorSet/index.vue'),
  //     },
  //     {
  //       path: 'pcMallDecorate/floorSet/edit/:id?',
  //       permission: '',
  //       hidden: true,
  //       meta: { title: '首页楼层编辑' },
  //       name: 'pcFloorSetEdit',
  //       component: () =>
  //         import(// @ts-ignore
  //         '../views/shopMall/pcMallDecorate/floorSet/edit/index.vue'),
  //     },
  //     {
  //       path: 'pcTopic',
  //       // permission: 'MallConfigManagement.Mall.PcTopic',
  //       hidden: true,
  //       meta: { title: '底部文章' },
  //       name: 'pcTopic',
  //       // @ts-ignore
  //       component: () => import('../views/shopMall/topic/index.vue'),
  //     },
  //     {
  //       path: 'pcTopic/edit/:id?',
  //       permission: '',
  //       hidden: true,
  //       meta: { title: '编辑文章' },
  //       name: 'editTopic',
  //       // @ts-ignore
  //       component: () => import('../views/shopMall/topic/edit/index.vue'),
  //     },
  //     {
  //       path: 'pcMallDecorate/headerSetting',
  //       // permission: 'MallConfigManagement.Mall.LogoSetting',
  //       hidden: true,
  //       icon: 'md-cube',
  //       meta: { title: 'logo设置' },
  //       name: 'headerSetting',
  //       groupName: 'PC商城',
  //       // @ts-ignore
  //       component: () =>
  //         import('../views/shopMall/pcMallDecorate/headerSet/index.vue'),
  //     },
  //     {
  //       path: 'pcMallDecorate/navColorSetting',
  //       // permission: 'MallConfigManagement.Mall.NavColorSetting',
  //       hidden: true,
  //       icon: 'md-cube',
  //       meta: { title: '导航栏底色设置' },
  //       name: 'navColorSetting',
  //       groupName: 'PC商城',
  //       // @ts-ignore
  //       component: () =>
  //         import('../views/shopMall/pcMallDecorate/navSet/navColorSet.vue'),
  //     },
  //   ],
  // },

  {
    path: '/goods',
    name: 'goods',
    permission: 'ProductManagement.Product',
    hidden: false,
    meta: { title: '商品' },
    icon: 'ios-pricetags-outline',
    component: main,
    children: [
      {
        path: 'list',
        permission: 'ProductManagement.Product.List',
        icon: 'md-ribbon',
        meta: { title: '商品列表' },
        name: 'GoodsList',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/list/index.vue'),
      },
      // {
      //   path: 'priceManagement',
      //   permission: 'ProductManagement.Product.List',
      //   icon: 'md-ribbon',
      //   meta: { title: '售价定时管理' },
      //   name: 'priceManagement',
      //   groupName: '常规商品',
      //   // @ts-ignore
      //   component: () => import('../views/goods/priceManagement/index.vue'),
      // },
      // {
      //   path: 'outfitClassify',
      //   permission: 'MarketingManagement.Center.Outfit',
      //   hidden: false,
      //   icon: 'md-ribbon',
      //   meta: { title: '套装分组' },
      //   name: 'outfitClassify',
      //   groupName: '常规商品',
      //   component: () => import('../views/goods/outfitClassify/list.vue'),
      // },
      {
        path: 'outfitCategory/action/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加/编辑套装分组' },
        name: 'OutfitCategoryAction',
        groupName: '常规商品',
        // @ts-ignore
        component: () =>
          import('../views/goods/outfitClassify/action/index.vue'),
      },
      // {
      //   path: 'outfitList',
      //   permission: 'MarketingManagement.Center.Outfit',
      //   icon: 'md-ribbon',
      //   meta: { title: '套装列表' },
      //   name: 'outfitList',
      //   groupName: '常规商品',
      //   component: () => import('../views/goods/outfitList/list.vue'),
      // },
      {
        path: 'outfitList/edit/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加套装' },
        name: 'OutfitGoodsEdit',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/outfitList/edit/index.vue'),
      },
      {
        path: 'importProduct',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '导入商品' },
        name: 'importProduct',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/productImport/index.vue'),
      },
      {
        path: 'batchEditProduct',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '批量修改' },
        name: 'batchEditProduct',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/batchEdit/index.vue'),
      },
      {
        path: 'list/edit/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加商品' },
        name: 'GoodsEdit',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/list/edit/index.vue'),
      },
      {
        path: 'category',
        permission: 'ProductManagement.ProductCategory.List',
        icon: 'md-ribbon',
        meta: { title: '商品分类' },
        name: 'GoodsCategory',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/category/index.vue'),
      },
      {
        path: 'customCategory',
        permission: 'ProductManagement.ProductCustomCategory.List',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '商品分组' },
        name: 'customCategory',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/customCategory/index.vue'),
      },
      {
        path: 'customCategory',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '分组商品列表' },
        name: 'customCategory',
        groupName: '常规商品',
        // @ts-ignore
        component: () =>
          import('../views/goods/customCategory/product/index.vue'),
      },
      {
        path: 'customCategory/edit/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '编辑商品分组' },
        name: 'customCategoryEdit',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/customCategory/edit/index.vue'),
      },
      {
        path: 'priceManagement/edit/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '编辑商品定时任务' },
        name: 'priceManagementEdit',
        groupName: '常规商品',
        // @ts-ignore
        component: () =>
          import('../views/goods/priceManagement/edit/index.vue'),
      },
      {
        path: 'category/eidt/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加商品分类' },
        name: 'GoodsCategoryEdit',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/category/edit/index.vue'),
      },
      {
        path: 'evaluate',
        permission: 'ProductManagement.ProductEvaluate.List',
        icon: 'md-ribbon',
        meta: { title: '商品评价' },
        name: 'GoodsEvaluate',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/evaluate/index.vue'),
      },
      {
        path: 'parameter',
        permission: 'ProductManagement.ProductParameter.List',
        icon: 'md-ribbon',
        meta: { title: '商品参数' },
        name: 'GoodsParameter',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/parameter/category/index.vue'),
      },
      {
        path: 'parameter/attr/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '商品参数列表' },
        name: 'GoodsParameterAttr',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/parameter/attribute/index.vue'),
      },
      {
        path: 'productRelated',
        permission: 'ProductManagement.ProductRelated.List',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '相关商品' },
        name: 'productRelated',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/related/index.vue'),
      },
      {
        path: 'productRelated/edit/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '编辑相关商品' },
        name: 'productRelatedEdit',
        groupName: '常规商品',
        // @ts-ignore
        component: () => import('../views/goods/related/edit/index.vue'),
      },
      {
        path: 'specs',
        permission: 'ProductManagement.ProductSpecs.List',
        icon: 'md-ribbon',
        meta: { title: '商品规格' },
        name: 'GoodsSpecs',
        groupName: '商品配置',
        // @ts-ignore
        component: () => import('../views/goods/specs/index.vue'),
      },
      {
        path: 'goodTag',
        permission: 'ProductManagement.ProductGoodTag.List',
        icon: 'md-pricetags',
        meta: { title: '标签列表', jsonUrl: 'form/good/tag/goodTag' },
        groupName: '商品配置',
        name: 'goodTag',
        component: defaultTable,
      },
      {
        path: 'brand',
        permission: 'ProductManagement.ProductBrand.List',
        icon: 'md-ribbon',
        meta: { title: '品牌列表' },
        name: 'brand',
        groupName: '商品配置',
        // @ts-ignore
        component: () => import('../views/goods/brand/index.vue'),
      },
      {
        path: 'wishList',
        permission: '',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '补货申请列表', jsonUrl: 'form/good/wishList' },
        name: 'wishList',
        groupName: '补货申请',
        component: defaultTable,
      },
      {
        path: 'specs/eidt/:id?',
        permission: '',
        hidden: true,
        meta: { title: '添加规格' },
        name: 'GoodsSpecsEdit',
        // @ts-ignore
        component: () => import('../views/goods/specs/edit/index.vue'),
      },
      {
        path: 'specs/brand/:id?',
        permission: '',
        hidden: true,
        meta: { title: '添加品牌' },
        name: 'goodsBrandEdit',
        // @ts-ignore
        component: () => import('../views/goods/brand/brandEdit/index.vue'),
      },
      {
        path: 'goodTag/eidt/:id?',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加标签', jsonUrl: 'form/good/tag/tagEdit' },
        name: 'goodTagEdit',
        groupName: '商品配置',
        component: defaultForm,
      },
      {
        path: 'evaluateDetail',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '评价详情' },
        name: 'evaluateDetail',
        // @ts-ignore
        component: () => import('../views/goods/evaluate/evaluateDetail.vue'),
      },
      {
        path: 'productRecommend',
        permission: 'ProductManagement.ProductRecommend.List',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '商品推荐' },
        name: 'productRecommend',
        groupName: '推荐管理',
        // @ts-ignore
        component: () => import('../views/goods/recommend/index.vue'),
      },
    ],
  },
  {
    path: '/order',
    name: 'order',
    permission: 'OrderManagement.Order',
    meta: { title: '订单' },
    icon: 'ios-list-box-outline',
    component: main,
    children: [
      {
        path: 'orderList',
        permission: 'OrderManagement.Order.List',
        icon: 'md-list-box',
        meta: { title: '订单列表' },
        name: 'orderList',
        groupName: '常规订单',
        component: () => import('../views/order/orderList/index.vue'),
      },
      // {
      //   path: 'refundList',
      //   permission: 'OrderManagement.Refund.List',
      //   icon: 'md-reorder',
      //   meta: { title: '退款申请处理' },
      //   name: 'refundList',
      //   groupName: '退款及退货',
      //   component: () => import('../views/order/refundList/index.vue')
      // },
      {
        path: 'refundList',
        permission: 'OrderManagement.Refund.List',
        icon: 'md-reorder',
        meta: { title: '退款申请处理' },
        name: 'refundList',
        groupName: '退款及退货',
        component: () => import('../views/order/refundList/newIndex.vue'),
      },
      {
        path: 'refundReasonsetting',
        permission: 'OrderManagement.RefundReason.List',
        icon: 'ios-paper',
        meta: { title: '退款原因设置' },
        name: 'refundReasonsetting',
        groupName: '退款及退货',
        component: () => import('../views/order/refundReasonsetting/index.vue'),
      },
      {
        path: 'logisticsTracking',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '物流跟踪' },
        name: 'logisticsTracking',
        groupName: '常规订单',
        component: () => import('../views/order/logisticsTracking/index.vue'),
      },
      {
        path: 'printOrder/:ids?',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '打印发货单' },
        name: 'printOrder',
        groupName: '常规订单',
        component: () => import('../views/order/printOrder/index.vue'),
      },
      {
        path: 'orderDetail',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '订单详情' },
        name: 'orderDetail',
        groupName: '常规订单',
        component: () => import('../views/order/orderDetail/index.vue'),
      },
      {
        path: 'exportExcelRecord',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '导出订单记录' },
        name: 'exportExcelRecord',
        groupName: '常规订单',
        component: () => import('../views/exportComRecord/index.vue'),
      },
      {
        path: 'deliverGood',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '订单发货' },
        name: 'deliverGood',
        groupName: '常规订单',
        component: () => import('../views/order/deliverGood/index.vue'),
      },
      // {
      //   path: 'refundDetail',
      //   permission: '',
      //   hidden: true,
      //   icon: 'md-list-box',
      //   meta: { title: '退款单详情' },
      //   name: 'refundDetail',
      //   groupName: '常规订单',
      //   component: () => import('../views/order/refundDetail/index.vue')
      // },
      {
        path: 'refundDetail',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '退款单详情' },
        name: 'refundDetail',
        groupName: '常规订单',
        component: () => import('../views/order/refundDetail/newIndex.vue'),
      },
      {
        path: 'order-reconciliation-list',
        permission: 'OrderManagement.OrderReconciliation.List',
        icon: 'md-cog',
        hidden: false,
        meta: { title: '对账单' },
        name: 'orderReconciliationList',
        groupName: '对账',
        component: () => import('@/views/order/reconciliation/index.vue'),
      },
      {
        path: 'order-reconciliation-detail',
        permission: '',
        icon: 'md-cog',
        hidden: true,
        meta: { title: '对账单详情' },
        name: 'orderReconciliationDetail',
        component: () =>
          import('@/views/order/reconciliation/detail/index.vue'),
      },
    ],
  },
  {
    path: '/member',
    name: 'member',
    permission: 'VipManagement.Member',
    meta: { title: '会员' },
    icon: 'ios-person',
    component: main,
    children: [
      {
        // VipManagement.Member.List
        path: 'memberList',
        permission: 'VipManagement.Member.List',
        icon: 'ios-person',
        meta: { title: '会员列表' },
        name: 'memberList',
        component: () => import('@/views/vip/list.vue'),
      },
      {
        path: 'vipTagList',
        permission: 'VipManagement.VipTag.List',
        icon: 'md-list-box',
        meta: { title: '会员标签' },
        name: 'vipTagList',
        component: () => import('@/views/vip/vipTag/index.vue'),
      },
      {
        path: 'storeWithdrawaList',
        permission: 'VipManagement.VipTag.List',
        icon: 'md-list-box',
        meta: { title: '储值审核列表' },
        name: 'storeWithdrawaList',
        component: () => import('@/views/vip/withDrawal/list.vue'),
      },
      {
        path: 'vipDetail',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '会员详情' },
        name: 'vipDetail',
        component: () => import('@/views/vip/vipDetail.vue'),
      },
      {
        path: 'editTag',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '添加标签' },
        name: 'editTag',
        component: () => import('@/views/vip/vipTag/editTag.vue'),
      },
      {
        path: 'memberAgreementSetting',
        permission: 'VipManagement.MemberAgreementSetting',
        icon: 'ios-copy',
        meta: { title: '会员协议设置', data: 'MemberAgreementConfig' },
        name: 'memberAgreementSetting',
        component: () =>
          import('../views/mallSetting/memberAgreementSetting/index.vue'),
      },
      {
        path: 'memberCardSetting',
        permission: '',
        icon: 'ios-card',
        hidden: true,
        meta: { title: '会员卡设置' },
        name: 'memberCardSetting',
        component: () =>
          import('../views/mallSetting/memberCardSetting/index.vue'),
      },
      {
        path: 'memberLevelSetting',
        permission: 'VipManagement.MemberLevelSetting',
        icon: 'ios-link',
        meta: { title: '会员等级设置' },
        name: 'memberLevelSetting',
        component: () =>
          import('../views/mallSetting/memberLevelSetting/index.vue'),
      },
      {
        path: 'rewardPointRuleSetting',
        permission: 'VipManagement.RewardPointRuleSetting',
        icon: 'ios-link',
        meta: { title: '积分规则配置' },
        name: 'rewardPointRuleSetting',
        component: () =>
          import('../views/mallSetting/rewardPointRuleSetting/index.vue'),
      },
      {
        path: 'memberInvitation',
        permission: 'VipManagement.RewardPointRuleSetting',
        icon: 'ios-link',
        meta: { title: '会员邀请入会' },
        name: 'memberInvitation',
        component: () =>
          import('../views/mallSetting/memberInvitation/index.vue'),
      },
      {
        path: 'couponExamine',
        permission: 'VipManagement.RewardPointRuleSetting',
        icon: 'ios-link',
        meta: { title: '优惠券核销' },
        name: 'couponExamine',
        component: () => import('@/views/vip/couponExamine/index.vue'),
      },
      {
        path: 'storevalueDetail',
        permission: 'VipManagement.RewardPointRuleSetting',
        icon: 'ios-link',
        meta: { title: '会员储值明细' },
        name: 'storevalueDetail',
        component: () => import('@/views/vip/storevalueDetail/list.vue'),
      },
    ],
  },
  {
    path: '/rewardPoint',
    name: 'rewardPoint',
    permission: 'MarketingManagement.PointMall',
    meta: { title: '积分商城' },
    icon: 'logo-buffer',
    component: main,
    children: [
      {
        path: 'banner',
        permission: 'MarketingManagement.PointMall.RewardPoint.List',
        icon: 'md-cube',
        meta: { title: '轮播图管理' },
        name: 'banner',
        component: () => import('../views/rewardPoint/banner/index.vue'),
      },
      // { path: 'productList', permission: '', icon: "md-cube", meta: { title: '积分商品列表', jsonUrl: 'form/rewardPoint/productList' }, name: 'productList', component: defaultTable },
      {
        path: 'productList',
        permission: 'MarketingManagement.PointMall.RewardPoint.List',
        icon: 'md-cube',
        meta: { title: '积分商品列表' },
        name: 'productList',
        component: () => import('../views/rewardPoint/product/index.vue'),
      },
      {
        path: 'product/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑积分商品' },
        name: 'productEdit',
        component: () => import('../views/rewardPoint/productEdit/index.vue'),
      },
      {
        path: 'rewardPointOrderList',
        permission: 'MarketingManagement.PointMall.RewardPointOrder.List',
        icon: 'md-list-box',
        meta: { title: '兑换订单列表' },
        name: 'rewardPointOrderList',
        component: () => import('../views/order/orderList/index.vue'),
      },
      // {
      //   path: 'turnTableList',
      //   permission: 'MarketingManagement.PointMall.TurnTableList.List',
      //   icon: 'md-cube',
      //   meta: {
      //     title: '大转盘列表',
      //     jsonUrl: 'form/rewardPoint/turnTableList',
      //   },
      //   name: 'turnTableList',
      //   component: defaultTable,
      // },
      // {
      //   path: 'scratchCardList',
      //   permission: 'MarketingManagement.PointMall.ScratchCardList.List',
      //   icon: 'md-cube',
      //   meta: {
      //     title: '刮刮卡列表',
      //     jsonUrl: 'form/rewardPoint/scratchCardList',
      //   },
      //   name: 'scratchCardList',
      //   component: defaultTable,
      // },
      {
        path: 'turnTableEdit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑大转盘活动', promotionType: '0' },
        name: 'turnTableEdit',
        component: () => import('../views/promotionGame/index.vue'),
      },
      {
        path: 'scratchCardEdit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑刮刮卡活动', promotionType: '1' },
        name: 'scratchCardEdit',
        component: () => import('../views/promotionGame/index.vue'),
      },
    ],
  },
  {
    path: '/marketing',
    name: 'marketing',
    permission: 'MarketingManagement.Center',
    meta: { title: '营销中心' },
    icon: 'md-cube',
    component: main,
    children: [
      {
        path: 'manager',
        permission: 'MarketingManagement.Center.LimitDiscount',
        icon: 'md-cube',
        meta: { title: '营销中心' },
        name: 'manager',
        component: () => import('../views/marketing/index.vue'),
      },
      {
        path: 'limitDiscount',
        permission: 'MarketingManagement.Center.LimitDiscount',
        icon: 'md-cube',
        meta: {
          title: '限时折扣',
          jsonUrl: 'form/marketing/limitDiscountList',
        },
        name: 'limitDiscount',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'preSales',
        permission: 'MarketingManagement.Center.PreSales',
        icon: 'md-cube',
        meta: { title: '预售', jsonUrl: 'form/marketing/preSalesList' },
        name: 'preSales',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'group',
        permission: 'MarketingManagement.Center.Group',
        icon: 'md-cube',
        meta: { title: '拼团', jsonUrl: 'form/marketing/groupList' },
        name: 'group',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'secKill',
        permission: 'MarketingManagement.Center.SecKill',
        icon: 'md-cube',
        meta: { title: '秒杀', jsonUrl: 'form/marketing/secKillList' },
        name: 'secKill',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'bargain',
        permission: 'MarketingManagement.Center.SecKill',
        icon: 'md-cube',
        meta: { title: '砍价', jsonUrl: 'form/marketing/bargainList' },
        name: 'bargain',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'buyGetOne',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '满X件免一', jsonUrl: 'form/marketing/buyGetOneList' },
        name: 'buyGetOne',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'tierDiscount',
        permission: 'MarketingManagement.Center.TierDiscount',
        icon: 'md-cube',
        meta: { title: '满减满折', jsonUrl: 'form/marketing/tierDiscountList' },
        name: 'tierDiscount',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'freeShipping',
        permission: '',
        icon: 'md-cube',
        // hidden: true,
        meta: { title: '满包邮', jsonUrl: 'form/marketing/freeShippingList' },
        name: 'freeShipping',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'productPack',
        permission: 'MarketingManagement.Center.ProductPack',
        icon: 'md-cube',
        meta: { title: '商品打包', jsonUrl: 'form/marketing/productPackList' },
        name: 'productPack',
        groupName: '商城促销',
        component: defaultTable,
      },
      // {
      //   path: 'outfit',
      //   permission: 'MarketingManagement.Center.Outfit',
      //   icon: 'md-cube',
      //   meta: { title: '套装活动', jsonUrl: 'form/marketing/outfitList' },
      //   name: 'outfit',
      //   groupName: '商城促销',
      //   component: defaultTable,
      // },
      {
        path: 'buyGetGiveaway',
        permission: 'MarketingManagement.Center.BuyGetGiveaway',
        icon: 'md-cube',
        meta: {
          title: '满送活动',
          jsonUrl: 'form/marketing/buyGetGiveawayList',
        },
        name: 'buyGetGiveaway',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'secondHalfPrice',
        permission: 'MarketingManagement.Center.BuyGetGiveaway',
        icon: 'md-cube',
        meta: {
          title: '第2件半价活动',
          jsonUrl: 'form/marketing/secondHalfPriceList',
        },
        name: 'secondHalfPrice',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'buyOneGetFreeOne',
        permission: 'MarketingManagement.Center.BuyGetGiveaway',
        icon: 'md-cube',
        meta: {
          title: '买一送一活动',
          jsonUrl: 'form/marketing/buyOneGetFreeOneList',
        },
        name: 'buyOneGetFreeOne',
        groupName: '商城促销',
        component: defaultTable,
      },
      // {
      //   path: 'fullGetCoupons',
      //   permission: 'MarketingManagement.Center.BuyGetGiveaway',
      //   icon: 'md-cube',
      //   meta: {
      //     title: '满额满折送券',
      //     jsonUrl: 'form/marketing/fullGetCouponList',
      //   },
      //   name: 'fullGetCoupons',
      //   groupName: '商城促销',
      //   component: defaultTable,
      // },
      {
        path: 'recharge',
        permission: 'MarketingManagement.Center.BuyGetGiveaway',
        icon: 'md-cube',
        meta: {
          title: '充值优惠',
          jsonUrl: 'form/marketing/rechargeActivityList',
        },
        name: 'recharge',
        groupName: '商城促销',
        component: defaultTable,
      },
      {
        path: 'rechargeCard',
        permission: 'MarketingManagement.Center.BuyGetGiveaway',
        icon: 'md-cube',
        meta: {
          title: '卡密',
          jsonUrl: 'form/marketing/rechargeCardActivityList',
        },
        name: 'rechargeCard',
        groupName: '商城促销',
        component: () => import('@/views/marketing/rechargeCard/list.vue'),
      },
      {
        path: 'rechargeCardProduct',
        permission: 'MarketingManagement.Center.BuyGetGiveaway',
        icon: 'md-cube',
        meta: {
          title: '卡密商品',
          jsonUrl: 'form/marketing/rechargeCardProductList',
        },
        name: 'rechargeCardProduct',
        groupName: '商城促销',
        component: () => import('@/views/marketing/rechargeCardProduct/list.vue'),
      },
      {
        path: 'rechargeCardCoupon',
        permission: 'MarketingManagement.Center.BuyGetGiveaway',
        icon: 'md-cube',
        meta: {
          title: '卡密换券',
          jsonUrl: 'form/marketing/rechargeCardCouponList',
        },
        name: 'rechargeCardCoupon',
        groupName: '商城促销',
        component: () => import('@/views/marketing/rechargeCardCoupon/list.vue'),
      },
      {
        path: 'rechargeEdit',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '编辑充值优惠' },
        name: 'rechargeEdit',
        groupName: '商城促销',
        component: () => import('@/views/marketing/rechargeActivity/index.vue'),
      },
      {
        path: 'rechargeCardEdit',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '编辑卡密' },
        name: 'rechargeCardEdit',
        groupName: '商城促销',
        component: () => import('@/views/marketing/rechargeCard/index.vue'),
      },
      {
        path: 'rechargeCardProductEdit',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '编辑卡密商品' },
        name: 'rechargeCardProductEdit',
        groupName: '商城促销',
        component: () => import('@/views/marketing/rechargeCardProduct/index.vue'),
      },
      {
        path: 'rechargeCardCouponEdit',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '编辑卡密换券' },
        name: 'rechargeCardCouponEdit',
        groupName: '商城促销',
        component: () => import('@/views/marketing/rechargeCardCoupon/index.vue'),
      },
      {
        path: 'fullGetCoupons/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑满额满件送券', promotionType: 'fullGetCoupons' },
        name: 'fullGetCouponsEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'secondHalfPrice/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑第2件半价', promotionType: 'halfPrice' },
        name: 'secondHalfPriceEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'buyOneGetFreeOne/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑买一送一', promotionType: 'buyGetOne' },
        name: 'buyOneGetFreeOneEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'limitDiscount/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑限时折扣', promotionType: 'limitDiscount' },
        name: 'limitDiscountEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'buyGetOne/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑买X件免一', promotionType: 'buyGetOne' },
        name: 'bugGetOneEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'tierDiscount/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑满减满折', promotionType: 'tierDiscount' },
        name: 'tierDiscountEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'freeShipping/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑满包邮', promotionType: 'freeShipping' },
        name: 'freeShippingEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'productPack/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑商品打包', promotionType: 'productPack' },
        name: 'productPackEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'outfit/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑套装活动', promotionType: 'outfit' },
        name: 'outfitEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'buyGetGiveaway/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑满送活动', promotionType: 'buyGetGiveaway' },
        name: 'buyGetGiveawayEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'preSales/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑预售活动', promotionType: 'preSales' },
        name: 'preSalesEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'group/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑拼团活动', promotionType: 'group' },
        name: 'groupEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'secKill/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑秒杀活动', promotionType: 'secKill' },
        name: 'secKillEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'bargain/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑砍价活动', promotionType: 'bargain' },
        name: 'bargainEdit',
        component: () =>
          import('../views/marketing/promotionActivity/index.vue'),
      },
      {
        path: 'couponList',
        permission: 'MarketingManagement.Center.CouponList',
        icon: 'md-cube',
        meta: { title: '优惠券', jsonUrl: 'form/marketing/couponList' },
        name: 'couponList',
        groupName: '优惠券中心',
        component: defaultTable,
      },
      {
        path: 'coupon/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑优惠券' },
        name: 'couponEdit',
        component: () => import('../views/marketing/coupon/index.vue'),
      },
      // {
      //   path: 'buyGetCoupon',
      //   permission: '',
      //   // hidden: true,
      //   icon: 'md-cube',
      //   meta: {
      //     title: '满额满件送券',
      //     jsonUrl: 'form/marketing/buyGetCouponList'
      //   },
      //   name: 'buyGetCoupon',
      //   groupName: '优惠券中心',
      //   component: defaultTable
      // },
      {
        path: 'limitBuyCoupon',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: {
          title: '限时购券',
          jsonUrl: 'form/marketing/limitBuyCouponList',
        },
        name: 'limitBuyCoupon',
        groupName: '优惠券中心',
        component: defaultTable,
      },
      {
        path: 'helpGetCoupon',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: {
          title: '助力领券',
          jsonUrl: 'form/marketing/helpGetCouponList',
        },
        name: 'helpGetCoupon',
        groupName: '优惠券中心',
        component: defaultTable,
      },
      // {
      //   path: 'grabCoupon',
      //   permission: 'MarketingManagement.Center.GrabCoupon',
      //   icon: 'md-cube',
      //   meta: {
      //     title: '抢优惠券',
      //     jsonUrl: 'form/marketing/grabCouponList',
      //   },
      //   name: 'grabCoupon',
      //   groupName: '优惠券中心',
      //   component: defaultTable,
      // },
      {
        path: 'couponReport',
        permission: 'MarketingManagement.Center.CouponReport',
        icon: 'md-cube',
        meta: {
          title: '优惠券报表',
          jsonUrl: 'form/marketing/couponReportList',
        },
        name: 'couponReport',
        groupName: '优惠券中心',
        component: defaultTable,
      },
      {
        path: 'activityStatistics',
        permission: 'MarketingManagement.Center.ActivityStatistics',
        icon: 'md-cube',
        meta: {
          title: '活动统计报表',
          jsonUrl: 'form/marketing/activityStatisticsList',
        },
        name: 'activityStatistics',
        groupName: '优惠券中心',
        component: defaultTable,
      },
      // { path: 'newComerGiftPack', permission: '', icon: "md-cube", meta: { title: '新人大礼包', jsonUrl: 'form/marketing/newComerGiftPackList' }, name: 'newComerGiftPack', groupName: '优惠券中心', component: defaultTable },
      // { path: 'questionnaireGetCoupon', permission: '', icon: "md-cube", meta: { title: '填问券送券', jsonUrl: 'form/marketing/questionnaireGetCouponList' }, name: 'questionnaireGetCoupon', groupName: '优惠券中心', component: defaultTable },
      // {
      //   path: 'buyGetCoupon/edit',
      //   permission: '',
      //   hidden: true,
      //   icon: 'md-cube',
      //   meta: { title: '编辑满额满件送券', promotionType: 'buyGetCoupon' },
      //   name: 'buyGetCouponEdit',
      //   component: () => import('../views/marketing/couponActivity/index.vue')
      // },
      {
        path: 'limitBuyCoupon/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑限时购券', promotionType: 'limitBuyCoupon' },
        name: 'limitBuyCouponEdit',
        component: () => import('../views/marketing/couponActivity/index.vue'),
      },
      {
        path: 'helpGetCoupon/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑助力领券', promotionType: 'helpGetCoupon' },
        name: 'helpGetCouponEdit',
        component: () => import('../views/marketing/couponActivity/index.vue'),
      },
      {
        path: 'grabCoupon/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: {
          title: '编辑抢优惠券',
          promotionType: 'grabCoupon',
        },
        name: 'grabCouponEdit',
        groupName: '优惠券中心',
        component: () => import('../views/marketing/couponActivity/index.vue'),
      },
      {
        path: 'newComerGiftPack/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑新人大礼包', promotionType: 'newComerGiftPack' },
        name: 'newComerGiftPackEdit',
        component: () => import('../views/marketing/couponActivity/index.vue'),
      },
      {
        path: 'questionnaireGetCoupon/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: {
          title: '编辑填问卷送券',
          promotionType: 'questionnaireGetCoupon',
        },
        name: 'questionnaireGetCouponEdit',
        component: () => import('../views/marketing/couponActivity/index.vue'),
      },
      {
        path: 'couponBag',
        permission: 'MarketingManagement.Center.CouponList',
        icon: 'md-cube',
        meta: { title: '券包管理', jsonUrl: 'form/marketing/couponBag' },
        name: 'couponBag',
        groupName: '优惠券中心',
        component: defaultTable,
      },
      {
        path: 'couponpackOrderList',
        permission: 'MarketingManagement.Center.CouponList',
        icon: 'md-list-box',
        meta: { title: '券包订单' },
        name: 'couponpackOrderList',
        groupName: '优惠券中心',
        component: () => import('../views/order/couponpack-order/index.vue'),
      },
      {
        path: 'couponpackOrderDetail',
        permission: '',
        hidden: true,
        icon: 'md-list-box',
        meta: { title: '订单详情' },
        name: 'couponpackOrderDetail',
        groupName: '优惠券中心',
        component: () => import('../views/order/couponpack-order-detail/index.vue'),
      },
      {
        path: 'editCouponbag',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加券包' },
        name: 'editCouponbag',
        component: () =>
          import('../views/marketing/couponbag/edit/index.vue'),
      },
      {
        path: 'couponbagDetail',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '券包详情' },
        name: 'couponbagDetail',
        component: () =>
          import('../views/marketing/couponbag/detail/index.vue'),
      },
      // {
      //   path: 'couponpackOrderreport',
      //   permission: 'MarketingManagement.Center.CouponList',
      //   icon: 'md-list-box',
      //   meta: { title: '券包统计' },
      //   name: 'couponpackOrderreport',
      //   groupName: '优惠券中心',
      //   component: () => import('../views/order/couponpack-order/report.vue'),
      // },
      {
        path: 'mission',
        permission: 'MarketingManagement.Center.ActivityStatistics',
        icon: 'md-cube',
        meta: { title: '任务有礼', jsonUrl: 'form/marketing/missionList' },
        name: 'mission',
        groupName: '积分活动',
        component: defaultTable,
      },
      {
        path: 'limitRewardPointExchange',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: {
          title: '限时积分兑换',
          jsonUrl: 'form/marketing/limitRewardPointExchangeList',
        },
        name: 'limitRewardPointExchange',
        groupName: '积分活动',
        component: defaultTable,
      },
      {
        path: 'mission/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑任务有礼', promotionType: 'mission' },
        name: 'missionEdit',
        component: () =>
          import('../views/marketing/rewardPointActivity/index.vue'),
      },
      {
        path: 'limitRewardPointExchange/edit',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: {
          title: '编辑限时积分兑换',
          promotionType: 'limitRewardPointExchange',
        },
        name: 'limitRewardPointExchangeEdit',
        component: () =>
          import('../views/marketing/rewardPointActivity/index.vue'),
      },
      {
        path: 'promotionActivityDetail',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '营销活动详情' },
        name: 'promotionActivityDetail',
        component: () =>
          import('../views/marketing/promotionActivity/detail/index.vue'),
      },
      {
        path: 'promotionActivityReport',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '营销活动统计' },
        name: 'promotionActivityReport',
        groupName: '商城促销',
        // component: () => import('../views/crowdfunding/order/index.vue'),
        component: () =>
          import('../views/marketing/promotionActivity/report/index.vue'),
      },
    ],
  },
  {
    path: '/employee',
    name: 'employee',
    permission: 'DistributionManagement',
    meta: { title: '分销' },
    icon: 'md-contacts',
    component: main,
    children: [
      // 导购
      // {
      //   path: 'employeeList',
      //   permission: '',
      //   icon: 'md-people',
      //   meta: { title: '导购列表' },
      //   hidden: true,
      //   name: 'employeeList',
      //   component: () => import('@/views/employee/list.vue')
      // },
      // {
      //   path: 'incomeList',
      //   permission: '',
      //   icon: 'logo-usd',
      //   meta: { title: '收益汇总' },
      //   name: 'incomeList',
      //   component: () => import('@/views/employee/income/list.vue')
      // },
      // {
      //   path: 'shareList',
      //   permission: '',
      //   icon: 'md-share',
      //   hidden: true,
      //   meta: { title: '导购分享' },
      //   name: 'shareList',
      //   component: () => import('@/views/employee/share/list.vue')
      // },
      // {
      //   path: 'editEmployee',
      //   hidden: true,
      //   permission: '',
      //   icon: 'md-people',
      //   meta: { title: '编辑导购信息' },
      //   name: 'editEmployee',
      //   component: () => import('@/views/employee/editEmployee.vue')
      // },
      // {
      //   path: 'employeeDetail',
      //   hidden: true,
      //   permission: '',
      //   icon: 'md-people',
      //   meta: { title: '导购详情' },
      //   name: 'employeeDetail',
      //   component: () => import('@/views/employee/employeeDetail.vue')
      // },
      // {
      //   path: 'shareDetail',
      //   hidden: true,
      //   permission: '',
      //   icon: 'md-people',
      //   meta: { title: '分享详情' },
      //   name: 'shareDetail',
      //   component: () => import('@/views/employee/share/shareDetail.vue')
      // },
      // 分销
      {
        // DistributionManagement.Distributor.List
        path: 'distributorList',
        permission: 'DistributionManagement.Distributor.List',
        icon: 'md-contacts',
        meta: { title: '分销员列表' },
        name: 'distributorList',
        component: () => import('@/views/distributor/list.vue'),
      },
      {
        path: 'editDistributorInfo',
        permission: '',
        hidden: true,
        icon: 'md-contacts',
        meta: { title: '修改分销员信息' },
        name: 'editDistributorInfo',
        component: () => import('@/views/distributor/editDistributionInfo.vue'),
      },
      // {
      //   path: 'distributorSetting',
      //   permission: '',
      //   hidden: true,
      //   icon: 'md-cog',
      //   meta: { title: '分销员配置' },
      //   name: 'distributorSetting',
      //   component: () => import('@/views/distributor/distributorSetting.vue')
      // },
      {
        path: 'distributorDetail',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '分销员详情' },
        name: 'distributorDetail',
        component: () => import('../views/distributor/distributorDetail.vue'),
      },
      {
        path: 'distributor-setting',
        permission: 'DistributionManagement.DistributorSetting',
        icon: 'md-cog',
        meta: { title: '分销配置' },
        name: 'newDistributorSetting',
        component: () => import('@/views/distributor/setting/index.vue'),
      },
      {
        path: 'withdrawal-list',
        permission: 'DistributionManagement.WithdrawalList.List',
        icon: 'md-cog',
        hidden: false,
        meta: { title: '提现审核' },
        name: 'withdrawalList',
        component: () => import('@/views/distributor/withdrawal/index.vue'),
      },
      {
        path: 'reconciliation-list',
        permission: 'DistributionManagement.Reconciliation.List',
        icon: 'md-cog',
        hidden: false,
        meta: { title: '提现对账' },
        name: 'reconciliationList',
        component: () => import('@/views/distributor/reconciliation/index.vue'),
      },
      {
        path: 'reconciliation-detail',
        permission: '',
        icon: 'md-cog',
        hidden: true,
        meta: { title: '提现对账详情' },
        name: 'reconciliationDetail',
        component: () =>
          import('@/views/distributor/reconciliation/detail/index.vue'),
      },
      {
        path: 'commission-statistics',
        permission: 'DistributionManagement.CommissionStatistics.List',
        icon: 'md-cog',
        hidden: false,
        meta: { title: '提佣统计表' },
        name: 'commissionStatistics',
        component: () => import('@/views/distributor/statisCommissionList.vue'),
      },
      {
        path: 'commission-list',
        permission: 'DistributionManagement.Commission.List',
        icon: 'md-cog',
        hidden: false,
        meta: { title: '佣金统计表' },
        name: 'commissionList',
        component: () => import('@/views/distributor/commissionList.vue'),
      },
      {
        path: 'replacement-audit-list',
        permission: 'DistributionManagement.ReplacementAudit.List',
        icon: 'md-cog',
        hidden: false,
        meta: { title: '换绑申请列表' },
        name: 'replacementauditlist',
        component: () =>
          import('@/views/distributor/replacementaudit/index.vue'),
      },
      // {
      //   path: 'commissionlistdetail',
      //   permission: '',
      //   icon: 'md-cog',
      //   hidden: true,
      //   meta: { title: '佣金统计个人详情' },
      //   name: 'commissionListDetail',
      //   component: () => import('@/views/distributor/commissionListItem.vue')
      // },
    ],
  },
  {
    path: '/article',
    name: 'article',
    permission: '',
    hidden: false,
    meta: { title: '文章管理' },
    icon: 'ios-book',
    component: main,
    children: [
      {
        path: 'articleList',
        permission: '',
        icon: 'md-bookmarks',
        meta: { title: '文章列表' },
        name: 'articleList',
        component: () => import('../views/article/list.vue'),
      },
      {
        path: 'articleCategoryList',
        permission: '',
        icon: 'ios-list-box',
        meta: {
          title: '文章分类',
          jsonUrl: 'form/article/articleCategory/list',
        },
        name: 'articleCategoryList',
        component: defaultTable,
      },
      {
        path: 'editArticleCategory',
        permission: '',
        hidden: true,
        icon: 'md-bookmarks',
        meta: { title: '添加文章分类' },
        name: 'editArticleCategory',
        component: () =>
          import('../views/article/articleCategory/editArticleCategory.vue'),
      },
      {
        path: 'articleTagList',
        permission: '',
        icon: 'md-bookmark',
        meta: { title: '文章标签', jsonUrl: 'form/article/articleTag/list' },
        name: 'articleTagList',
        component: defaultTable,
      },
      {
        path: 'editArticle',
        permission: '',
        hidden: true,
        icon: 'md-bookmarks',
        meta: { title: '编辑文章' },
        name: 'editArticle',
        component: () => import('../views/article/editArticle.vue'),
      },
      {
        path: 'editArticleTag',
        permission: '',
        hidden: true,
        icon: 'md-bookmarks',
        meta: { title: '添加文章标签' },
        name: 'editArticleTag',
        component: () =>
          import('../views/article/articleTag/editArticleTag.vue'),
      },
      {
        path: 'articleDetail',
        permission: '',
        hidden: true,
        icon: 'md-bookmarks',
        meta: { title: '文章详情' },
        name: 'articleDetail',
        component: () => import('../views/article/articleDetail.vue'),
      },
    ],
  },
  {
    path: '/question',
    name: 'question',
    permission: '',
    hidden: true,
    meta: { title: '问卷管理' },
    icon: 'ios-list-box',
    component: main,
    children: [
      {
        path: 'questionList',
        permission: '',
        icon: 'ios-list-box',
        meta: { title: '问卷列表', jsonUrl: 'form/question/list' },
        name: 'questionList',
        component: defaultTable,
      },
      {
        path: 'answerQuestionList',
        permission: '',
        hidden: true,
        icon: 'ios-list-box',
        meta: { title: '答卷列表', jsonUrl: 'form/question/answer/list' },
        name: 'answerQuestionList',
        component: defaultTable,
      },
      {
        path: 'viewUeserQuestion',
        permission: '',
        hidden: true,
        icon: 'ios-list-box',
        meta: { title: '答卷详情' },
        name: 'viewUeserQuestion',
        component: () => import('../views/question/answerDetail.vue'),
      },
      {
        path: 'questionDetail',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '问卷统计' },
        name: 'questionDetail',
        component: () => import('../views/question/questionDetail.vue'),
      },
      {
        path: 'editQuestion',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '编辑问卷' },
        name: 'editQuestion',
        component: () => import('../views/question/editQuestion.vue'),
      },
    ],
  },
  {
    path: '/mall',
    name: 'mall',
    permission: 'MallConfigManagement.Setting',
    meta: { title: '设置' },
    icon: 'md-settings',
    component: main,
    children: [
      {
        path: 'basicSetting',
        permission: 'MallConfigManagement.Setting.BasicSetting',
        icon: 'md-cube',
        meta: { title: '基础设置' },
        name: 'basicSetting',
        component: () => import('../views/mallSetting/basicSetting/index.vue'),
      },
      {
        path: 'carouselSetting',
        permission: '',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '会员中心轮播图设置' },
        name: 'carouselSetting',
        component: () => import('../views/mallSetting/carousel/index.vue'),
      },
      {
        path: 'advertSetting',
        permission: 'MallConfigManagement.Setting.AdvertSetting',
        icon: 'md-photos',
        meta: { title: '弹窗广告设置' },
        name: 'advertSetting',
        component: () => import('../views/mallSetting/advertSetting/index.vue'),
      },
      {
        path: 'productAdvertSetting',
        permission: 'MallConfigManagement.Setting.ProductAdvertSetting',
        icon: 'md-photos',
        meta: { title: '商品详情广告设置' },
        name: 'productAdvertSetting',
        component: () =>
          import('../views/mallSetting/productAdvertSetting/index.vue'),
      },
      {
        path: 'mallDiyList',
        permission: 'MallConfigManagement.Setting.MallDiyList.List',
        icon: 'md-home',
        meta: { title: '微页面' },
        name: 'mallDiyList',
        component: () => import('../views/mallSetting/homeSetting/list.vue'),
      },
      {
        path: 'categoriesSetting',
        permission: 'MallConfigManagement.Setting.CategoriesSetting',
        icon: 'md-list',
        meta: { title: '分类页' },
        name: 'categoriesSetting',
        component: () =>
          import('../views/mallSetting/categoriesSetting/index.vue'),
      },
      {
        path: 'homeSetting',
        permission: '',
        hidden: true,
        icon: 'md-home',
        meta: { title: '商城装修' },
        name: 'homeSetting',
        component: () => import('../views/mallSetting/homeSetting/index.vue'),
      },
      {
        path: 'paySetting',
        permission: 'MallConfigManagement.Setting.PaySetting',
        icon: 'logo-buffer',
        meta: { title: '支付设置' },
        name: 'paySetting',
        component: () => import('../views/mallSetting/paySetting/index.vue'),
      },
      {
        path: 'mallUrlSetting',
        permission: 'MallConfigManagement.Setting.MallUrlSetting',
        icon: 'md-basket',
        meta: { title: '商城路径设置' },
        name: 'mallUrlSetting',
        component: () =>
          import('../views/mallSetting/mallUrlSetting/index.vue'),
      },
      // {
      //   path: 'pcMallUrlSetting',
      //   permission: 'MallConfigManagement.Setting.PcMallUrlSetting',
      //   icon: 'md-basket',
      //   meta: { title: 'PC商城路径设置' },
      //   name: 'pcMallUrlSetting',
      //   component: () =>
      //     import('../views/mallSetting/pcMallUrlSetting/index.vue'),
      // },
      {
        path: 'hotSearchKeyWord',
        permission: 'MallConfigManagement.Setting.HotSearchKeyWord.List',
        icon: 'md-search',
        meta: {
          title: '热门搜索词',
          jsonUrl: 'form/mall/hotSearchKeyWord/list',
        },
        name: 'hotSearchKeyWord',
        component: defaultTable,
      },
      {
        path: 'shippingCompany',
        permission: 'MallConfigManagement.Setting.ShippingCompany.List',
        icon: 'md-ribbon',
        meta: {
          title: '物流公司列表',
          jsonUrl: 'form/mall/shipping/companyList',
        },
        name: 'shippingCompany',
        component: defaultTable,
      },
      {
        path: 'shippingSetting',
        permission: 'MallConfigManagement.Setting.ShippingCompany.List',
        icon: 'md-pin',
        meta: { title: '配送设置' },
        name: 'shippingSetting',
        component: () => import('../views/mallSetting/shippingSetting/index.vue'),
      },
      {
        path: 'kuaiDiNiaoApi',
        permission: 'MallConfigManagement.Setting.KuaiDiNiaoApi',
        icon: 'md-settings',
        meta: { title: '快递鸟设置' },
        name: 'kuaiDiNiaoApi',
        component: () => import('../views/mallSetting/kuaiDiNiaoApi/index.vue'),
      },
      {
        path: 'shippingList',
        permission: '',
        icon: 'md-ribbon',
        hidden: true,
        meta: { title: '运费模板' },
        name: 'shippingList',
        component: () => import('../views/mallSetting/shipping/index.vue'),
      },
      {
        path: 'editCompany',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加物流公司' },
        name: 'editCompany',
        component: () =>
          import('../views/mallSetting/shipping/editCompany.vue'),
      },
      {
        path: 'editShippingTemplate',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加运费模板' },
        name: 'editShippingTemplate',
        component: () =>
          import('../views/mallSetting/shipping/editShippingTemplate.vue'),
      },
      {
        path: 'editHotSearchKeyWord',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加热门搜索词' },
        name: 'editHotSearchKeyWord',
        component: () =>
          import('../views/mallSetting/hotSearchKeyWord/editHotSearchKeyWord.vue'),
      },
      // 相册
      {
        path: 'photoAlbum',
        permission: 'MallConfigManagement.Setting.PhotoAlbum.List',
        icon: 'md-cube',
        meta: { title: '相册列表', jsonUrl: 'form/photo/photoAlbumList' },
        name: 'photoAlbum',
        component: defaultTable,
      },
      // 主图
      // {
      //   path: 'promotionFrame',
      //   permission: 'MallConfigManagement.Setting.PhotoAlbum.List',
      //   icon: 'md-cube',
      //   meta: { title: '主图管理' },
      //   name: 'promotionFrame',
      //   component: () => import('../views/picture/promotionFrame/index.vue'),
      // },
      {
        path: 'pictureList',
        permission: '',
        hidden: true,
        icon: 'md-cube',
        meta: { title: '图片' },
        name: 'pictureList',
        component: () => import('../views/picture/index.vue'),
      },
      {
        path: 'photoAlbum/eidt',
        permission: '',
        hidden: true,
        icon: 'md-ribbon',
        meta: { title: '添加相册', jsonUrl: 'form/photo/photoAlbumEdit' },
        name: 'photoAlbumEdit',
        component: defaultForm,
      },
      // {
      //   path: 'shop',
      //   permission: 'MallConfigManagement.Setting.Shop.List',
      //   icon: 'md-cube',
      //   meta: { title: '店铺列表' },
      //   name: 'shop',
      //   component: () => import('../views/mallSetting/shop/index.vue'),
      // },
      {
        path: 'addShop',
        permission: '',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '新增店铺' },
        name: 'addShop',
        component: () => import('../views/mallSetting/shop/addshop.vue'),
      },
      {
        path: 'editShop',
        permission: '',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '修改店铺' },
        name: 'editShop',
        component: () => import('../views/mallSetting/shop/editshow.vue'),
      },
      {
        path: 'registerAgreementSetting',
        permission: 'MallConfigManagement.Setting.RegisterAgreementSetting',
        icon: 'ios-copy',
        meta: { title: '注册协议设置', data: 'RegisterAgreementConfig' },
        name: 'registerAgreementSetting',
        component: () =>
          import('../views/mallSetting/memberAgreementSetting/index.vue'),
      },
      {
        path: 'privacyAgreementSetting',
        permission: 'MallConfigManagement.Setting.PrivacyAgreementSetting',
        icon: 'ios-copy',
        meta: { title: '隐私协议设置', data: 'PrivacyAgreementConfig' },
        name: 'privacyAgreementSetting',
        component: () =>
          import('../views/mallSetting/memberAgreementSetting/index.vue'),
      },
      // {
      //   path: 'sizeImage',
      //   permission: 'MallConfigManagement.Setting.SizeImage',
      //   icon: 'ios-copy',
      //   meta: { title: '尺码指南设置', data: 'SizeGroupConfig' },
      //   name: 'sizeImage',
      //   component: () =>
      //     import('../views/mallSetting/memberAgreementSetting/index.vue'),
      // },
      {
        path: 'mpUserList',
        permission: '',
        icon: 'md-cube',
        hidden: true,
        meta: { title: '公众号粉丝列表' },
        name: 'mpUserList',
        component: () => import('../views/wechat/mpUser/list/index.vue'),
      },
    ],
  },
  {
    path: '/authority',
    name: 'authority',
    hidden: false,
    permission: 'AbpIdentity',
    meta: { title: '权限' },
    icon: 'md-lock',
    component: main,
    children: [
      {
        path: 'membermanagement',
        permission: 'AbpIdentity.Users',
        icon: 'md-cube',
        meta: { title: '成员管理' },
        name: 'membermanagement',
        groupName: '权限管理',
        component: () => import('../views/authority/member.vue'),
      },
      {
        path: 'rolesmanagement',
        permission: 'AbpIdentity.Roles',
        icon: 'md-cube',
        meta: { title: '角色管理' },
        name: 'rolesmanagement',
        groupName: '权限管理',
        component: () => import('../views/authority/roles.vue'),
      },
      {
        path: 'permission',
        hidden: true,
        permission: '',
        icon: 'md-people',
        meta: { title: '权限设置' },
        name: 'permission',
        component: () => import('@/views/authority/operating/permission.vue'),
      },
      {
        path: 'authoritySet',
        hidden: true,
        permission: '',
        icon: 'md-people',
        meta: { title: '权限设置' },
        name: 'authoritySet',
        component: () => import('@/views/authority/operating/authoritySet.vue'),
      },
      {
        path: 'editUser',
        hidden: true,
        permission: '',
        icon: 'md-people',
        meta: { title: '编辑用户' },
        name: 'editUser',
        component: () => import('@/views/authority/operating/editUser.vue'),
      },
      {
        path: 'addUser',
        hidden: true,
        permission: '',
        icon: 'md-people',
        meta: { title: '新增用户' },
        name: 'addUser',
        component: () => import('@/views/authority/operating/editUser.vue'),
      },
      {
        path: 'addRole',
        hidden: true,
        permission: '',
        icon: 'md-people',
        meta: { title: '新增角色' },
        name: 'addRole',
        component: () => import('@/views/authority/operating/editRoles.vue'),
      },
      {
        path: 'editRole',
        hidden: true,
        permission: '',
        icon: 'md-people',
        meta: { title: '修改角色' },
        name: 'editRole',
        component: () => import('@/views/authority/operating/editRoles.vue'),
      },
    ],
  },
  // {
  //   path: '/report',
  //   name: 'report',
  //   permission: '',
  //   hidden: false,
  //   meta: { title: '报表' },
  //   icon: 'md-albums',
  //   component: main,
  //   children: [
  //     {
  //       path: 'orderReport',
  //       permission: '',
  //       icon: 'md-cube',
  //       meta: { title: '订单报表' },
  //       name: 'orderReport',
  //       groupName: '订单报表',
  //       component: () => import('../views/report/order')
  //     },
  //   ]
  // },
]
export const routers = [
  locking,
  organizationRouters,
  ...appRouters,
  otherRouters,
  ...loginRouter,
  ...anonymousRouter,
  promotionActivityRouter,
]
